import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { GetDynamicPageDataResponse } from '@/modules/client-setting/type'
import { columns } from './constants'
interface DynamicPageTableProps {
	data: GetDynamicPageDataResponse[]
	total: number
	isLoading?: boolean
}

export default function DynamicPageTable({
	data,
	total,
	isLoading,
}: DynamicPageTableProps) {
	return (
		<div className="space-y-4">
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
